/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/reviews'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Reviews from '@routes/Reviews';

export const Route = createFileRoute('/reviews/')({
  component: () => <CacheDataRoute component={Reviews} path='/reviews' />
});
